(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wzlt-buy-now-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wzlt-buy-now-button')) {
    class WzltBuyNowButton extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('[data-variant-input]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.submitButton = this.querySelector('[data-buy-now-submit]');
        this.textEl = this.querySelector('[data-buy-now-text]');
        this.checkoutUrl = this.dataset.checkoutUrl || '/checkout';
        this.cartAddJsUrl = this.dataset.cartAddJsUrl || '/cart/add.js';
        this.cartClearUrl = this.dataset.cartClearUrl || '/cart/clear.js';
        this.clearCart = this.dataset.clearCart === 'true';
        this.soldOutLabel = this.dataset.soldOutLabel || 'Lorem ipsum';
        this.loadingLabel = this.dataset.loadingLabel || 'Lorem ipsum';
        this.defaultLabel = this.textEl ? this.textEl.textContent.trim() : '';
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId || '';
        this._variantsById = this._parseVariants(this.dataset.variants);

        if (!this.form || !this.variantInput || !this.submitButton) return;

        if (this.sectionId) {
          this._section = document.getElementById('shopify-section-' + this.sectionId);
        }

        this._onVariantEvent = this._onVariantEvent.bind(this);
        this._onShopifyProductSelect = this._onShopifyProductSelect.bind(this);
        this._onDocumentChange = this._onDocumentChange.bind(this);
        this._onPickerPointer = this._onPickerPointer.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
        this._onQuantityChange = this._onQuantityChange.bind(this);
        this._stopPropagation = this._stopPropagation.bind(this);
        this._onPopState = this._onPopState.bind(this);

        document.addEventListener('variant:change', this._onVariantEvent);
        document.addEventListener('variant:changed', this._onVariantEvent);
        document.addEventListener('variant:update', this._onVariantEvent);
        document.addEventListener('variant:selected', this._onVariantEvent);
        document.addEventListener('product:select', this._onVariantEvent);
        document.addEventListener('shopify:product:select', this._onShopifyProductSelect);
        document.addEventListener('change', this._onDocumentChange, true);
        document.addEventListener('click', this._onPickerPointer, true);
        window.addEventListener('popstate', this._onPopState);

        this.form.addEventListener('submit', this._onSubmit, true);
        this.submitButton.addEventListener('click', this._stopPropagation, true);
        this._bindMainProductForm();
        this._syncFromPage();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:change', this._onVariantEvent);
        document.removeEventListener('variant:changed', this._onVariantEvent);
        document.removeEventListener('variant:update', this._onVariantEvent);
        document.removeEventListener('variant:selected', this._onVariantEvent);
        document.removeEventListener('product:select', this._onVariantEvent);
        document.removeEventListener('shopify:product:select', this._onShopifyProductSelect);
        document.removeEventListener('change', this._onDocumentChange, true);
        document.removeEventListener('click', this._onPickerPointer, true);
        window.removeEventListener('popstate', this._onPopState);
        this._unbindMainProductForm();
        if (this._variantObserver) {
          this._variantObserver.disconnect();
          this._variantObserver = null;
        }
      }

      _stopPropagation(event) {
        event.stopPropagation();
      }

      _parseVariants(raw) {
        var map = {};
        if (!raw) return map;
        try {
          var list = JSON.parse(raw);
          if (!Array.isArray(list)) return map;
          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (!item || item.id == null) continue;
            map[String(item.id)] = item;
          }
        } catch (err) {}
        return map;
      }

      _normalizeVariantId(value) {
        if (value == null || value === '') return '';
        var text = String(value);
        var match = text.match(/(\d+)\s*$/);
        return match ? match[1] : text;
      }

      _variantIdFromNode(node) {
        if (!node) return '';
        if (node.getAttribute) {
          var dataId = node.getAttribute('data-variant-id');
          if (dataId) return this._normalizeVariantId(dataId);
        }
        if (node.dataset && node.dataset.variantId) {
          return this._normalizeVariantId(node.dataset.variantId);
        }
        if (node.options && node.selectedIndex >= 0) {
          var option = node.options[node.selectedIndex];
          if (option && option.getAttribute) {
            var optionId = option.getAttribute('data-variant-id');
            if (optionId) return this._normalizeVariantId(optionId);
          }
        }
        if (node.name === 'id' && node.value) return this._normalizeVariantId(node.value);
        return '';
      }

      _isMainProductScope(el) {
        if (!el || !el.closest) return false;
        if (el.closest('product-card') || el.closest('quick-add-dialog') || el.closest('quick-add-modal')) {
          return false;
        }
        return true;
      }

      _readVariantIdFromPage() {
        var pickers = document.querySelectorAll('variant-picker');
        for (var i = 0; i < pickers.length; i++) {
          var picker = pickers[i];
          if (!this._isMainProductScope(picker)) continue;
          var checked = picker.querySelector('input[data-variant-id]:checked, input[type="radio"]:checked');
          if (checked) {
            var checkedId = this._variantIdFromNode(checked);
            if (checkedId) return checkedId;
          }
          var selectedOption = picker.querySelector(
            'select option[selected][data-variant-id], select option:checked[data-variant-id]'
          );
          if (selectedOption) {
            var selectedId = this._variantIdFromNode(selectedOption);
            if (selectedId) return selectedId;
          }
        }

        var fallbackChecked = document.querySelector(
          '.product-information input[data-variant-id]:checked, .product-details input[data-variant-id]:checked, input[data-variant-id]:checked'
        );
        if (fallbackChecked && this._isMainProductScope(fallbackChecked)) {
          var fallbackId = this._variantIdFromNode(fallbackChecked);
          if (fallbackId) return fallbackId;
        }

        var scope = this._section || document;
        var inputs = scope.querySelectorAll(
          'form.shopify-product-form input[name="id"], product-form-component input[name="id"], product-form input[name="id"], [data-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"]'
        );
        for (var j = 0; j < inputs.length; j++) {
          var input = inputs[j];
          if (input === this.variantInput) continue;
          if (!this._isMainProductScope(input)) continue;
          if (input.value) return this._normalizeVariantId(input.value);
        }

        var params = new URLSearchParams(window.location.search);
        if (params.get('variant')) return this._normalizeVariantId(params.get('variant'));

        return this.variantInput ? this._normalizeVariantId(this.variantInput.value) : '';
      }

      _readQuantityFromPage() {
        var scope = this._section || document;
        var qty = scope.querySelector(
          'quantity-selector-component input[name="quantity"], quantity-input input[name="quantity"], form.shopify-product-form input[name="quantity"], product-form-component input[name="quantity"], [data-product-form] input[name="quantity"]'
        );
        if (qty && qty.value) {
          var n = parseInt(qty.value, 10);
          if (n > 0) return String(n);
        }
        return this.quantityInput ? this.quantityInput.value : '1';
      }

      _idFromEvent(event) {
        if (!event) return '';
        var fromTarget = this._variantIdFromNode(event.target);
        if (fromTarget) return fromTarget;

        var detail = event.detail || {};
        if (detail.variantId) return this._normalizeVariantId(detail.variantId);
        if (detail.detail && detail.detail.variantId) {
          return this._normalizeVariantId(detail.detail.variantId);
        }
        var variant = detail.variant || (detail.data && detail.data.variant);
        if (variant && variant.id != null) return this._normalizeVariantId(variant.id);
        var resource = detail.resource || (detail.data && detail.data.resource);
        if (resource && resource.id != null) return this._normalizeVariantId(resource.id);
        return '';
      }

      _bindMainProductForm() {
        var scope = this._section || document;
        var mainForm =
          scope.querySelector('product-form-component form') ||
          scope.querySelector('form.shopify-product-form') ||
          scope.querySelector('product-form form') ||
          scope.querySelector('[data-product-form] form') ||
          document.querySelector('product-form-component form') ||
          document.querySelector('form.shopify-product-form');

        if (!mainForm || mainForm === this.form) return;

        this._mainForm = mainForm;
        this._mainVariantInput = mainForm.querySelector('input[name="id"], select[name="id"]');
        this._mainQuantityInput = mainForm.querySelector('input[name="quantity"]');

        if (this._mainVariantInput) {
          this._mainVariantInput.addEventListener('change', this._onVariantEvent);
          this._mainVariantInput.addEventListener('input', this._onVariantEvent);
          if (typeof MutationObserver === 'function') {
            var self = this;
            this._lastSeenVariantId = this._normalizeVariantId(this._mainVariantInput.value);
            this._variantObserver = new MutationObserver(function () {
              self._syncFromPage();
            });
            this._variantObserver.observe(this._mainVariantInput, {
              attributes: true,
              attributeFilter: ['value', 'disabled']
            });
            if (this._mainForm) {
              this._variantObserver.observe(this._mainForm, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['value', 'checked', 'aria-checked', 'selected']
              });
            }
          }
        }

        if (this._mainQuantityInput) {
          this._mainQuantityInput.addEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.addEventListener('input', this._onQuantityChange);
        }
      }

      _unbindMainProductForm() {
        if (this._mainVariantInput) {
          this._mainVariantInput.removeEventListener('change', this._onVariantEvent);
          this._mainVariantInput.removeEventListener('input', this._onVariantEvent);
        }
        if (this._mainQuantityInput) {
          this._mainQuantityInput.removeEventListener('change', this._onQuantityChange);
          this._mainQuantityInput.removeEventListener('input', this._onQuantityChange);
        }
      }

      _onPickerPointer(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('variant-picker') && !target.closest('.variant-picker') && !target.closest('[data-option-value-id]')) {
          return;
        }
        if (!this._isMainProductScope(target)) return;
        var self = this;
        requestAnimationFrame(function () {
          self._syncFromPage();
          setTimeout(function () {
            self._syncFromPage();
          }, 50);
        });
      }

      _syncFromPage() {
        var variantId = this._readVariantIdFromPage();
        if (variantId) this._setVariant(variantId, null);
        if (this.quantityInput) this.quantityInput.value = this._readQuantityFromPage();
      }

      _onPopState() {
        this._syncFromPage();
      }

      _onDocumentChange(event) {
        var target = event.target;
        if (!target) return;

        var fromNode = this._variantIdFromNode(target);
        if (fromNode) {
          this._setVariant(fromNode, null);
          return;
        }

        if (target.name === 'quantity') {
          this._onQuantityChange(event);
          return;
        }

        if (target.closest && target.closest('variant-picker') && this._isMainProductScope(target)) {
          this._syncFromPage();
        }
      }

      _onQuantityChange(event) {
        if (!this.quantityInput) return;
        var quantity = parseInt(event.target.value, 10);
        this.quantityInput.value = quantity > 0 ? String(quantity) : '1';
      }

      _onVariantEvent(event) {
        var id = this._idFromEvent(event) || this._readVariantIdFromPage();
        if (!id) return;
        var available = null;
        var detail = event && event.detail ? event.detail : {};
        var variant = detail.variant || (detail.data && detail.data.variant);
        if (variant && typeof variant.available === 'boolean') available = variant.available;
        else if (variant && typeof variant.availableForSale === 'boolean') {
          available = variant.availableForSale;
        }
        this._setVariant(id, available);
      }

      _onShopifyProductSelect(event) {
        var self = this;
        var apply = function (result) {
          var variant = result && result.variant ? result.variant : result;
          if (!variant || variant.id == null) {
            self._syncFromPage();
            return;
          }
          var available =
            typeof variant.availableForSale === 'boolean'
              ? variant.availableForSale
              : typeof variant.available === 'boolean'
                ? variant.available
                : null;
          self._setVariant(self._normalizeVariantId(variant.id), available);
        };

        if (event && event.promise && typeof event.promise.then === 'function') {
          event.promise.then(apply).catch(function () {
            self._syncFromPage();
          });
          return;
        }

        this._onVariantEvent(event);
      }

      _setVariant(variantId, isAvailable) {
        var id = this._normalizeVariantId(variantId);
        if (!id || !this.variantInput) return;

        this.variantInput.value = id;
        this.variantInput.disabled = false;

        var available = isAvailable;
        if (typeof available !== 'boolean' && this._variantsById[id]) {
          available = !!this._variantsById[id].available;
        }
        if (typeof available === 'boolean') {
          this._setAvailability(available);
        }
      }

      _setAvailability(isAvailable) {
        if (!this.submitButton || !this.textEl) return;

        this.submitButton.disabled = !isAvailable;
        this.submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        this.textEl.textContent = isAvailable ? this.defaultLabel : this.soldOutLabel;
      }

      _setLoading(isLoading) {
        if (!this.submitButton || !this.textEl) return;
        this.submitButton.disabled = isLoading;
        this.submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        this.textEl.textContent = isLoading ? this.loadingLabel : this.defaultLabel;
      }

      _goToCheckout() {
        window.location.href = this.checkoutUrl;
      }

      async _onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        this._syncFromPage();

        var variantId = this._normalizeVariantId(this.variantInput.value);
        var quantity = parseInt(this.quantityInput.value, 10) || 1;

        if (!variantId) return;

        var variantMeta = this._variantsById[variantId];
        if (variantMeta && variantMeta.available === false) {
          this._setAvailability(false);
          return;
        }

        if (this.submitButton.disabled && this.submitButton.getAttribute('aria-busy') !== 'true') {
          return;
        }

        this._setLoading(true);

        try {
          if (this.clearCart) {
            await fetch(this.cartClearUrl, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
          }

          var response = await fetch(this.cartAddJsUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: quantity }]
            })
          });

          var data = await response.json();

          if (!response.ok) {
            throw new Error(data.description || data.message || 'No se pudo agregar el producto.');
          }

          this._goToCheckout();
        } catch (error) {
          this._setLoading(false);
          if (this.textEl) {
            this.textEl.textContent = error.message || 'Error al procesar la compra.';
          }
        }
      }
    }

    customElements.define('wzlt-buy-now-button', WzltBuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

})();
